"use client";
import React from "react";

const VideoPlayer = ({
  src,
  poster,
  autoPlay = false,
  loop = false,
  muted = true,
  controls = true,
  className = "",
}) => {
  return (
    <div className={`aspect-video w-full ${className}`}>
      <video
        src={src}
        controls={controls}
        autoPlay={autoPlay}
        muted={muted}
        loop={loop}
        poster={poster}
        className="w-full h-full object-cover border-none"
      >
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;
